import { getActiveSession } from "../../utils/nightStayAccount";

// Local identity binding prevents a response for one account surviving logout
// or account switching. This key is never sent as proof of server identity.
export const getSavingsViewerKey = () => {
  const session = getActiveSession();
  return session ? String(session._id || session.id || session.email || session.phone || "") : "";
};
